import React, { useEffect as _useEffect, useState as _useState } from 'react'
import './index.less'
import pic from '@/assets/images/add_pic.png'
import SearchPanel from './SearchPanel/index'
import ComparePanel from './ComparePanel/index'
import { useAppDispatch, useAppSelector } from '@/hooks'
import { setShowType } from '@/features/SetCompareInfo/setCompareInfo'
export interface searchResultI {
  workId: string
  workName: string
  museum: string //博物馆
  mediaType: string //材质
  materialType: string //设色
  styleType: string //形制
  horizontal?: number //高
  vertical?: number //宽
  authorName: string
  dynasty: string
  class1: string //主题
  class2: string //类型
  tilesPath: string //tilesPath
  src: string //缩略图
}

//画作对比
export function ComparisonPage() {
  const dispatch = useAppDispatch()
  const showType = useAppSelector((state) => state.compareInfo.showType)
  return (
    <>
      {showType === 0 ? (
        <div className='add-pic'>
          <img src={pic} alt='add_pic' onClick={() => dispatch(setShowType(1))} />
        </div>
      ) : showType === 1 ? (
        <div className='search-panel'>
          <SearchPanel />
        </div>
      ) : (
        <div className='compare-panel'>
          <ComparePanel />
        </div>
      )}
    </>
  )
}
